export function hexToRgb(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [255, 255, 255]
}
export function rgb(value: [number, number, number]) {
  return `rgb(${value.join(',')})`
}
export function rgba(value: [number, number, number], a = 1, base = 'inherit') {
  if (base === 'inherit') {
    return `rgba(${[...value, a].join(',')})`
  }
  const baseRGB = hexToRgb(base)
  const [rr, gg, bb] = value.map((c, i) => Math.floor(c * a + baseRGB[i] * (1 - a)))
  return rgb([rr, gg, bb])
}
